import MarsImage from './mars-image/index.vue';
import HermesDownloadBtn from './hermes-download-btn/index.vue';
export default (Vue) => {
   Vue.component('MarsImage', MarsImage);
 Vue.component('HermesDownloadBtn', HermesDownloadBtn);
}